/* eslint-disable no-nested-ternary, react/prop-types */
import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'

import { DEFAULT_GLUE } from './constants'
import { sumAgesFromString } from 'lib/paxes'

import IconChildren from 'client/icons/Children'
import IconPerson from 'client/icons/Person'

import { IconWrapper, Adults, CapacityBase, Paxes, Children, Separator } from './styles'
import messages from './messages'

type Props = {
  adults: number
  children: number
  childrenAges: string
  glue?: string
  showAges?: boolean
  showIcons?: boolean
  title?: boolean
}

const Capacity = ({
  adults,
  children = 0,
  childrenAges,
  glue = DEFAULT_GLUE,
  showAges = true,
  showIcons = true,
  title = true,
}: Props) => {
  const intl = useIntl()

  const messageAdults = messages[adults === 1 ? 'adult' : 'adults']
  const messageChildren = messages[children === 1 ? 'child' : 'children']

  const agesTotal = sumAgesFromString(childrenAges)
  const messageChildrenAges = messages[agesTotal === 1 ? 'singularChildrenAges' : 'childrenAges']

  const translations = {
    adults: intl.formatMessage(messageAdults),
    children: intl.formatMessage(messageChildren),
    childrenAges: intl.formatMessage(messageChildrenAges, { children_ages: childrenAges }),
  }

  const paxAges = children > 0 ? `(${translations.childrenAges})` : ''
  const paxChildren =
    children > 0
      ? showAges
        ? `${glue}${children} ${translations.children} ${paxAges}`
        : `${glue}${children} ${translations.children}`
      : ''

  const people = [...Array(adults).keys()] // build an array from a number

  const Icons = () =>
    children >= 1 ? (
      <IconWrapper>
        <IconPerson />
        <IconChildren />
      </IconWrapper>
    ) : adults >= 4 ? (
      <IconWrapper>
        <IconPerson />
      </IconWrapper>
    ) : (
      <IconWrapper>
        {people.map(pax => (
          <IconPerson key={pax} />
        ))}
      </IconWrapper>
    )

  return (
    <CapacityBase>
      {title && <FormattedMessage {...messages.capacity} tagName="p" />}

      <Paxes showIcons={showIcons} showTitle={title} data-testid="capacity-message">
        {showIcons && <Icons />}
        {adults >= 4 && showIcons && <Separator>{' x '}</Separator>}

        <Adults>{`${adults} ${translations.adults}`}</Adults>
        <Children>{paxChildren}</Children>
      </Paxes>
    </CapacityBase>
  )
}

export default Capacity
